import React from 'react'

import { Card, CardContent, CardHeader } from '@mui/material'
import format from 'date-fns/format'
import { useParams } from 'react-router-dom'

import LoadingView from 'components/LoadingView'
import { DescriptionListTable } from 'components/table'
import { useCampaignBilling } from 'hooks/useCampaignBilling'

const config = [
  {
    title: 'Upcoming Invoice Total Amount',
    render: ({ amountDue, currency }: any) => `${amountDue / 100} ${currency}`,
  },
  {
    title: 'Current recorded usage',
    field: 'usage',
  },
  {
    title: 'Period start',
    render: ({ periodStart }: any) => format(periodStart, 'yyyy-MM-dd HH:mm:ss'),
  },
  {
    title: 'Period end',
    render: ({ periodEnd }: any) => format(periodEnd, 'yyyy-MM-dd HH:mm:ss'),
  },
]

const CampaignCurrentPeriodSummary = () => {
  const { id } = useParams()
  const { data: billing, isLoading, error } = useCampaignBilling(id)

  return (
    <Card sx={{ mb: '1rem' }}>
      <CardHeader title="Current period" />
      <CardContent>
        <LoadingView error={error ? 'Error occurred when loading billing summary data' : undefined} loading={isLoading}>
          <DescriptionListTable config={config} data={billing} />
        </LoadingView>
      </CardContent>
    </Card>
  )
}

export default CampaignCurrentPeriodSummary
